export default __webpack_public_path__ + "static/media/ic_gmx_custom.e9ef7077.svg";